import { buildScopedI18n } from '../../utils/buildScopedI18n';
import outboundEsCL from './locales/es-CL.json';
import outboundEnUS from './locales/en-US.json';
import outboundPtBR from './locales/pt-BR.json';

export const escriturasOutboundI18n = buildScopedI18n({
  esCL: outboundEsCL,
  enUS: outboundEnUS,
  ptBR: outboundPtBR,
});
